/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from 'react'
import styles from '../css/ReferenceScheme.module.css'
import plusIcon from "../images/plus.svg";
import SetupStyles from "../css/SetupForm.module.css";
import { v4 as uuid } from "uuid";
import Context from '../context/context'
import { CancelRounded } from '@mui/icons-material';
import { PencilAltIcon } from "@heroicons/react/solid";
import { openDB } from "idb";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';

const newScheme = {
    type: "ref",
    first_person: {
        discount_type: "P",
        value: "",
        max_limit: 'N',
        paymode_uuid: ""
    },
    second_person: {
        discount_type: "P",
        value: "",
        max_limit: 'N',
        paymode_uuid: 'D',
        min_bill_amt: "N"
    },
    scheme_status: 1,
    items: [],
    valid_type: "0",
    scheme_title: ""
}

const options = {
    validity: [
        { value: '0', label: 'None' },
        { value: 'Fixed', label: 'Fixed' },
        { value: 'Relative', label: 'Relative' }
    ],
    discount_type: [
        { value: 'P', label: '%' },
        { value: 'A', label: 'AMT' }
    ]
}

const ReferenceSchemeManagePOPUP = ({ close }) => {

    const context = useContext(Context);
    const { updateUnSync } = context;

    const [schemeFormState, setSchemeFormState] = useState({ status: true, data: {} })
    const [schemes, setSchemes] = useState([])
    const [payModes, setPayModes] = useState([])

    useEffect(() => {
        const fetchSchemes = async () => {
            try {
                let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
                let store = db.transaction("scheme", "readonly").objectStore("scheme");
                const schemes = await store.getAll()

                if (schemes?.length > 0) setSchemes(schemes);
                else console.error('No schemes found')

                let paymodes = await db.transaction("payment_modes", "readonly").objectStore("payment_modes").getAll();
                setPayModes(paymodes?.filter(mode => mode?.maintain_customer_balance === 'Y').map(mode => {
                    return {
                        value: mode.payment_mode_uuid,
                        label: mode.payment_mode_name
                    }
                }))
            } catch (error) {
                console.error(error)
            }
        }
        fetchSchemes();
    }, [])

    const addScheme = () => {
        setSchemes([...schemes, {
            ...newScheme, first_person: { ...newScheme.first_person, paymode_uuid: payModes?.[0]?.value },
            scheme_uuid: uuid(), new: true, outlet_uuid: localStorage.getItem('outlet_uuid')
        }])
    }

    const editHandler = e => {
        e.preventDefault();
        const scheme_uuid = e.target?.getAttribute('uuid')
        const scheme = schemes?.find(i => i.scheme_uuid === scheme_uuid)

        if (scheme && scheme.scheme_title) {
            setSchemeFormState({ isOpen: true, data: scheme })
        }
    }

    const submitHandler = async e => {

        e.preventDefault();
        try {

            console.log(schemes)
            let schemes_docs = await [...schemes]
            const newSchemes = schemes_docs.filter(i => i.new)
            const editedSchemes = schemes_docs.filter(i => i.edited)
            console.log(newSchemes)
            console.log(editedSchemes)

            let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
            let store = db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
            let schemeStore = db.transaction("scheme", "readwrite").objectStore("scheme");

            if (newSchemes?.[0]) {
                console.log("new shcemes : ", newSchemes)
                newSchemes.forEach(({ new: _new, edited, ...scheme }) => {
                    store.put({ ...scheme, IDENTIFIER: `Scheme-new:${scheme.scheme_uuid}`, BACKUP: 0 })
                    schemeStore.put({ ...scheme, IDENTIFIER: scheme.scheme_uuid })
                })
                setSchemes(schemes.map(({ new: _isNew, ...doc }) => doc))
            }

            if (editedSchemes?.[0]) {
                console.log("edites dshcemes : ", editedSchemes)
                editedSchemes.forEach(({ new: _new, edited, ...scheme }) => {
                    store.put({ ...scheme, IDENTIFIER: `Scheme-edit:${scheme.scheme_uuid}`, BACKUP: 0 })
                    schemeStore.put({ ...scheme, IDENTIFIER: scheme.scheme_uuid })
                })
                setSchemes(schemes.map(({ edited, ...doc }) => doc))
                close()
            }
            else
                close()

            updateUnSync()
        } catch (error) {
            console.error(error)
        }
    }

    const inputHandler = async (e, value) => {
        setSchemes(schemes.map(i => {
            if (i.scheme_uuid === (e.target.id.split(':')[1])) {
                console.log(i)
                console.log(value)
                return { ...i, [e.target.name]: (value ? +value : e.target.value), edited: !i.new };
            } else
                return i;
        }))
    }

    const updateSchemesState = async scheme => {
        setSchemes(schemes.map(i => i.scheme_uuid === scheme.scheme_uuid ? scheme : i))
    }

    return (
        <>
            <div className={styles.popupContainer}>
                <div className={styles.popupBody}>
                    <h2>Reference Scheme Manage</h2>
                    <div>
                        <div className={styles.formsContainer}>
                            {
                                schemes?.length > 0
                                    ? schemes.map(scheme =>
                                        <form className='input-div' onSubmit={editHandler} uuid={scheme.scheme_uuid}>
                                            <input type='text' id={`text:${scheme.scheme_uuid}`} name='scheme_title' placeholder='Scheme Title' value={scheme.scheme_title} onChange={inputHandler} required />
                                            <label htmlFor={`checkbox:${scheme.scheme_uuid}`}>
                                                <input type="checkbox" name='scheme_status' id={`checkbox:${scheme.scheme_uuid}`} checked={Boolean(+scheme?.scheme_status)} onChange={e => inputHandler(e, `${+e.target.checked}`)} />
                                                <div className="checkmark"></div>
                                            </label>
                                            <button type='submit'>Edit</button>
                                        </form>)
                                    :
                                    <div className={styles.noSchemeMessage}>No Schemes available</div>
                            }
                        </div>
                        <div className={styles.btnContainer}>
                            <button type="button" className={SetupStyles.addMealButton} onClick={addScheme}>
                                <img src={plusIcon} alt='plus' />
                            </button>
                            <button className={styles.submitBtn} onClick={submitHandler} disabled={!(schemes.find(i => i.new) || schemes.find(i => i.edited))}>Save</button>
                        </div>
                    </div>
                    <CancelRounded onClick={close} className={styles.close} />
                </div>
            </div>
            {schemeFormState?.isOpen && <ReferenceSchemeForm schemeFormState={schemeFormState} setSchemeFormState={setSchemeFormState} updateSchemesState={updateSchemesState} payModes={payModes} />}
        </>
    )
}

export const ReferenceSchemeForm = ({ schemeFormState, setSchemeFormState, updateSchemesState, payModes }) => {

    const context = useContext(Context);
    const { updateUnSync } = context;
    const [schemeData, setSchemeData] = useState(schemeFormState?.data)
    const [validityType, setValidityType] = useState(null)
    const [selectedPayModes, setSelectedPayModes] = useState({})

    useEffect(() => {
        console.log(schemeData)
        if (schemeData && !validityType) {
            const validity = {
                disabled: +schemeData?.valid_type === 0
            }

            if (schemeData?.valid_type === '0')
                validity.value = '0'
            else if (schemeData?.valid_type?.length === 13)
                validity.value = 'Fixed'
            else if (schemeData?.valid_type)
                validity.value = 'Relative'

            setValidityType(validity)
        }
    }, [schemeData])

    const submitHandler = async e => {
        e.preventDefault()
        console.log(schemeData)
        const { new: _new, edited, ...doc } = await schemeData;

        let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        let store = db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
        let schemeTx = db.transaction("scheme", "readwrite").objectStore("scheme");

        if (_new) {
            store.add({ ...doc, IDENTIFIER: `Scheme-new:${schemeData.scheme_uuid}`, BACKUP: 0 })
            schemeTx.add({ ...doc, IDENTIFIER: schemeData.scheme_uuid })
        }
        else {
            store.put({ ...doc, IDENTIFIER: `Scheme-edit:${schemeData.scheme_uuid}`, BACKUP: 0 })
            schemeTx.put({ ...doc, IDENTIFIER: schemeData.scheme_uuid })
        }

        updateSchemesState({ ...doc })
        setSchemeFormState({ isOpen: false })
        updateUnSync()
    }

    const updatePersonDetail = (person_index, key, value) => {
        console.log({ person_index, key, value })
        if (+person_index > 2)
            setSchemeData(curr => ({
                ...curr, other_persons: schemeData.other_persons
                    ?.map(i => i.person_index === person_index ? { ...i, [key]: value } : i)
            }))
        else {
            if (key === 'commission_distribution')
                setSchemeData(curr => ({
                    ...curr,
                    first_person: {
                        ...curr.first_person,
                        ...(value?.map(({ commission, ...i }) => ({ ...i, value: commission }))?.[0])
                    }
                }))
            else
                setSchemeData(curr => ({
                    ...curr, second_person: { ...curr.second_person, [key]: value }
                }))
        }
    }

    const [commissionPopup, setCommissionPopup] = useState({ status: false, data: [] })
    const addPersonToScheme = () => {
        const existingPersonsCount = schemeData?.other_persons?.length + 2 || 2
        const person = {
            person_index: `${existingPersonsCount + 1}`,
            discount_type: "P",
            value: "",
            max_limit: 'N',
            paymode_uuid: 'D',
            min_bill_amt: "N",
            commission_distribution: [
                { person_index: '1', discount_type: 'P', commission: '' },
                { person_index: '2', discount_type: 'P', commission: '' }
            ]
        }
        schemeData?.other_persons?.forEach(i => person?.commission_distribution?.push({ person_index: i.person_index, discount_type: 'P', commission: '' }))
        let other_persons = schemeData?.other_persons?.map(i => ({
            ...i, paymode_uuid: i?.paymode_uuid === 'D' ? payModes?.[0]?.value : i?.paymode_uuid
        })) || []
        other_persons.push(person)
        setSchemeData(curr => ({
            ...curr,
            second_person: {
                ...curr.second_person,
                paymode_uuid: curr.second_person?.paymode_uuid === 'D' ? payModes?.[0]?.value : curr.second_person?.paymode_uuid
            },
            other_persons
        }))
    }

    const SelectWallet = ({ value, onChange, isLast }) => {
        return (
            <label htmlFor="">
                Select Wallet
                <Select
                    className={isLast ? 'scheme_select_small_container' : 'scheme_select_container'}
                    classNamePrefix='scheme_select'
                    value={value}
                    onChange={onChange}
                    options={payModes}
                />
            </label>
        )
    }

    const handleDiscountCheckbox = (e, person_index) => {
        const value = e.target.checked ? 'D' : selectedPayModes?.[person_index] || payModes?.[0]?.value
        updatePersonDetail(person_index, 'paymode_uuid', value)
        if (!e.target.checked && !selectedPayModes?.[person_index])
            setSelectedPayModes(doc => ({ ...doc, [person_index]: payModes?.[0]?.value }))
    }

    return (
        <div className={styles.scheme_form_popup_container}>
            <div className={styles.formHead}>
                <h2>Reference Scheme Form</h2>
                <CancelRounded onClick={e => setSchemeFormState({ isOpen: false })} className={styles.close} />
            </div>
            <div className={styles.scheme_form_container}>
                <form className={styles.scheme_form} onSubmit={submitHandler}>

                    <div className={styles.inputGroupDiv}>
                        <label htmlFor="validity">
                            Validity
                            <Select
                                className='scheme_select_container'
                                classNamePrefix='scheme_select'
                                value={options?.validity?.find(i => {
                                    if (validityType?.disabled && i.value === '0')
                                        return i
                                    else if (i.value === validityType?.value)
                                        return i
                                    else
                                        return ''
                                })}
                                onChange={({ value: selected, ...obj }) => {
                                    console.log(selected)
                                    setSchemeData({
                                        ...schemeData, valid_type: 0
                                    })
                                    if (selected !== '0')
                                        setValidityType({ value: selected })
                                    else {
                                        setValidityType({ ...validityType, disabled: true })
                                        setSchemeData({ ...schemeData, valid_type: '0' })
                                    }
                                }}
                                options={options?.validity}
                            />
                        </label>

                        <label htmlFor="date-selector">
                            Select date
                            {validityType?.value === 'Fixed'
                                ? <DatePicker
                                    shouldCloseOnSelect={true}
                                    id="date-selector"
                                    className={`date-picker ${styles.date_selector}`}
                                    dateFormat={'dd/MM/yy'}
                                    selected={new Date(`${schemeData?.valid_type}`.length === 13 ? +schemeData?.valid_type : Date.now() + (3600000 * 24))}
                                    minDate={new Date(Date.now() + (3600000 * 24))}
                                    onChange={date => {
                                        setSchemeData({
                                            ...schemeData, valid_type: new Date(new Date(date).setHours(23, 59, 0, 0)).setUTCHours(0, 0, 0, 0)
                                        })
                                    }}
                                    wrapperClassName={styles.datePicker}
                                    disabled={validityType?.disabled}
                                /> :
                                <input
                                    type="text"
                                    className={styles.inputs}
                                    min={1}
                                    placeholder="Enter number of days"
                                    value={schemeData?.valid_type}
                                    onChange={e => {
                                        let value = `${e.target.value}`
                                        if (/^[0-9]{0,12}$/.test(value)) {
                                            setSchemeData({
                                                ...schemeData, valid_type: +value
                                            })
                                        }
                                    }}
                                    disabled={validityType?.disabled}
                                />
                            }
                        </label>
                    </div>

                    <h2>1st Person</h2>

                    <div className={styles.inputGroupDiv}>
                        <label htmlFor="1p-discount">
                            Maximum Discount
                            <input
                                className={styles.inputs}
                                type='number'
                                name="1p-discount"
                                id="1p-discount"
                                max={100}
                                min={0}
                                value={schemeData?.first_person?.max_limit}
                                onChange={e => setSchemeData({
                                    ...schemeData, first_person: {
                                        ...schemeData.first_person, max_limit: e.target.value
                                    }
                                })}
                            />
                        </label>

                        <label>
                            Select wallet
                            <div style={{ position: 'relative' }}>
                                <Select
                                    className='scheme_select_container'
                                    classNamePrefix='scheme_select'
                                    value={payModes.find(i => i.value === schemeData?.first_person?.paymode_uuid) || { label: schemeData?.first_person?.paymode_uuid }}
                                    onChange={({ value: selected, ...obj }) => {
                                        setSchemeData({
                                            ...schemeData, first_person: {
                                                ...schemeData.first_person, paymode_uuid: selected
                                            }
                                        })
                                    }}
                                    options={payModes}
                                />
                                <input type="text" className={styles.requiredInput} value={schemeData?.first_person?.paymode_uuid} required />
                            </div>
                        </label>
                    </div>

                    {schemeData?.second_person && [{ ...schemeData?.second_person, person_index: '2' }]
                        ?.concat(schemeData?.other_persons || [])
                        ?.map(person => {
                            const isLast = +person.person_index === 2 + (schemeData?.other_persons?.length || 0);
                            const heading = `${person.person_index}${+person.person_index === 2 ? 'nd' : +person.person_index === 3 ? 'rd' : 'th'} Person`

                            return <>
                                <h2>{heading}</h2>

                                <div className={styles.inputGroupDiv}>
                                    <label htmlFor=''>
                                        Discount
                                        <div>
                                            <input className={`${styles.inputs} ${styles.inputs_sided}`} type='number' name="2p-discount" id="2p-discount" max={
                                                person?.discount_type === "A" ? undefined : 100
                                            } min={
                                                person?.discount_type === "A" ? 100 : 0
                                            }
                                                value={person?.value}
                                                onChange={e => updatePersonDetail(person.person_index, 'value', e.target.value)}
                                                required
                                            />
                                            <Select
                                                className='scheme_select_sided_container'
                                                classNamePrefix='scheme_select'
                                                value={options.discount_type?.find(i => i.value === person?.discount_type)}
                                                onChange={({ value: selected, ...obj }) => updatePersonDetail(person.person_index, 'discount_type', selected)}
                                                options={options?.discount_type}
                                            />
                                        </div>
                                    </label>

                                    <label>
                                        Maximum discount
                                        <input className={styles.inputs} type='number' name="max-discount" id="max-discount" max={100} min={0}
                                            value={person?.max_limit} onChange={e => updatePersonDetail(person.person_index, 'max_limit', e.target.value)} />
                                    </label>

                                    <label>
                                        Minimum bill amount
                                        <input className={styles.inputs} type='number' name="min-bill-amt" id="min-bill-amt" min={0} max={99999}
                                            value={person?.min_bill_amt} onChange={e => updatePersonDetail(person.person_index, 'min_bill_amt', e.target.value)} />
                                    </label>

                                    {isLast ?
                                        <label htmlFor=''>
                                            Payment Mode
                                            <div className={styles.payModesDiv}>
                                                <label htmlFor="2p-cash">
                                                    Direct Discount
                                                    <input
                                                        className={styles.inputCheckbox}
                                                        type="checkbox"
                                                        id='2p-cash'
                                                        checked={person?.paymode_uuid === 'D'}
                                                        onChange={e => handleDiscountCheckbox(e, person?.person_index)}
                                                    />
                                                </label>
                                                <SelectWallet
                                                    isLast={isLast}
                                                    value={payModes?.find(i => i.value === person?.paymode_uuid) || { label: person?.paymode_uuid }}
                                                    onChange={({ value: selected, ...obj }) => {
                                                        setSelectedPayModes(curr => ({ ...curr, [person.person_index]: selected }))
                                                        updatePersonDetail(person.person_index, 'paymode_uuid', selected)
                                                    }}
                                                />
                                            </div>
                                        </label>
                                        : <SelectWallet
                                            value={payModes?.find(i => i.value === person?.paymode_uuid) || { label: person?.paymode_uuid }}
                                            onChange={({ value: selected, ...obj }) => {
                                                setSelectedPayModes(curr => ({ ...curr, [person.person_index]: selected }))
                                                updatePersonDetail(person.person_index, 'paymode_uuid', selected)
                                            }}
                                        />
                                    }

                                    <label>
                                        Commission Distribution
                                        <button className={styles.commissionManageBtn} onClick={e => {
                                            e.preventDefault()
                                            setCommissionPopup({
                                                status: true,
                                                data: +person.person_index === 2
                                                    ? [{ ...schemeData?.first_person, person_index: 1 }]
                                                    : person.commission_distribution,
                                                heading,
                                                person_index: person.person_index
                                            })
                                        }}>
                                            Manage <PencilAltIcon style={{ width: '20px' }} />
                                        </button>
                                    </label>
                                </div>
                            </>
                        })}

                    <div style={{ margin: '15px 0 0 auto' }}>
                        <button type="button" className={SetupStyles.addMealButton} onClick={addPersonToScheme}>
                            <img src={plusIcon} alt='plus' />
                        </button></div>

                    <div className={`${SetupStyles.formGroup} ${styles.messagePopupContainer}`}>
                        <h2>Display Message</h2>
                        <div className={SetupStyles.row}>
                            <label className={SetupStyles.selectLabel}>
                                <textarea
                                    className={SetupStyles.messageTextarea}
                                    value={schemeData?.message || '{COUPON-CODE}'}
                                    onChange={e => {
                                        if (e.target.value.includes('{COUPON-CODE}') && e.target.value.split('\n').length < 6)
                                            setSchemeData({ ...schemeData, message: e.target.value })
                                    }}
                                    maxLength={250}
                                />
                            </label>
                        </div>
                    </div>
                    <button type='submit' className={styles.saveBtn}>Save</button>
                </form>
            </div>
            {commissionPopup?.status && <CommissionManagePopup
                state={commissionPopup}
                close={() => setCommissionPopup(curr => ({ ...curr, status: !curr?.status }))}
                save={value => updatePersonDetail(commissionPopup?.person_index, 'commission_distribution', value)}
            />}
        </div>
    )
}

const CommissionManagePopup = ({ state, close, save }) => {

    const [distribution, setDistribution] = useState(state?.data)
    const onChange = (person_index, key, value) => setDistribution(curr => curr?.map(i => i.person_index === person_index ? { ...i, [key]: value } : i))

    return <div className={styles.commissionManagePopupContainer}>
        <div className={styles.scheme_form_popup_container}>
            <div className={styles.formHead}>
                <h2 style={{ fontSize: '21px' }}>Commission Distribution For {state?.heading}</h2>
                <CancelRounded onClick={close} className={styles.close} />
            </div>
            <div className={styles.scheme_form_container}>
                <form className={styles.scheme_form} onSubmit={e => { e.preventDefault(); save(distribution); close() }}>
                    <div className={styles.inputGroupDiv}>
                        {distribution?.map(person =>
                            <label htmlFor=''>
                                {person.person_index}{+person.person_index === 1 ? 'st' : +person.person_index === 2 ? 'nd' : +person.person_index === 3 ? 'rd' : 'th'} Person
                                <div>
                                    <input
                                        className={`${styles.inputs} ${styles.inputs_sided}`}
                                        type='number'
                                        name="2p-discount" id="2p-discount"
                                        max={person?.discount_type === "A" ? undefined : 100}
                                        min={person?.discount_type === "A" ? 100 : 0}
                                        value={person?.commission || person?.value}
                                        onChange={e => onChange(person.person_index, 'commission', e.target.value)}
                                        required
                                    />
                                    <Select
                                        className='scheme_select_sided_container'
                                        classNamePrefix='scheme_select'
                                        value={options.discount_type?.find(i => i.value === person?.discount_type)}
                                        onChange={({ value: selected, ...obj }) => onChange(person.person_index, 'discount_type', selected)}
                                        options={options?.discount_type}
                                    />
                                </div>
                            </label>
                        )}
                    </div>
                    <button type='submit' className={styles.saveBtn}>Save</button>
                </form>
            </div>
        </div>
    </div>
}

export default ReferenceSchemeManagePOPUP